import { render, staticRenderFns } from "./versionlist.vue?vue&type=template&id=5f920bf2&scoped=true&"
import script from "./versionlist.vue?vue&type=script&lang=js&"
export * from "./versionlist.vue?vue&type=script&lang=js&"
import style0 from "./versionlist.vue?vue&type=style&index=0&id=5f920bf2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f920bf2",
  null
  
)

export default component.exports